export default {
  path: '/mobile',
  title: '移动端',
  icon: 'phone',
  hideSub: true,
  children: (pre => [
    {
      title: 'APP',
      icon: 'dot-circle-o',
      path: `${pre}app`
    },
    {
      title: '移动直播',
      icon: 'dot-circle-o',
      path: `${pre}zb`
    },
    {
      title: '小程序',
      icon: 'dot-circle-o',
      path: `${pre}mp`
    }
  ])('/mobile/')
}
